import { getTranslatedNaceSectorLabel } from "@/constants/naceSectors";

function toTitleCase(value: string): string {
  return value
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function formatSectorLabel(sector: string | null | undefined): string {
  if (!sector) {
    return "Not specified";
  }

  return getTranslatedNaceSectorLabel(sector) ?? toTitleCase(sector);
}
